import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges, inject} from '@angular/core';
import {MediaUrlPipe} from '../pipes/media-url.pipe';

@Directive({
  selector: '[appVideoSrc]',
  standalone: true
})
export class VideoSrcDirective implements OnInit, OnChanges {
  private el: ElementRef<HTMLSourceElement> = inject(ElementRef);
  private mediaUrlPipe: MediaUrlPipe = new MediaUrlPipe();
  private currentSourceUrl: string = '';

  @Input() public fileName: string | undefined = undefined;

  public ngOnInit(): void {
    this.updateSource();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileName']) {
      this.updateSource();
    }
  }

  private updateSource(): void {
    const sourceUrl = this.fileName ? this.mediaUrlPipe.transform(this.fileName) ?? '' : '';
    if (sourceUrl === this.currentSourceUrl) {
      return;
    }

    this.currentSourceUrl = sourceUrl;
    this.el.nativeElement.src = sourceUrl;
    this.parentVideoElement()?.load();
  }

  private parentVideoElement(): HTMLVideoElement | null {
    const parentElement = this.el.nativeElement.parentElement;
    return parentElement instanceof HTMLVideoElement ? parentElement : null;
  }
}
